/**
 * rule-restricted.guard.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanLoad,
  Route,
  RouterStateSnapshot
} from "@angular/router";
import { Observable } from "rxjs/Rx";
import { UserService } from "../auth/identity/user.service";
import { Rule } from "../auth/permissions/rules";
import { arrayIntersects, identity } from "../support/utilities/functions";

@Injectable()
export class RuleRestrictedGuard implements CanActivate, CanLoad
{
  constructor (private users : UserService) {}

  private run (data : any) : Observable<boolean>
  {
    if (!Array.isArray(data.rules))
    {
      console.error(data);
      throw new Error("Guard requires route data to contain 'rules' list");
    }
    return (this.users.ready as Observable<boolean>).first(identity).map(
      () => arrayIntersects(data.rules, this.users.self.aggregateRules));
  }

  public canActivate (
    route : ActivatedRouteSnapshot,
    state : RouterStateSnapshot
  ) : Observable<boolean>
  {
    return this.run(route.data);
  }

  public canLoad (route : Route) : Observable<boolean>
  {
    return this.run(route.data);
  }

}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/routing/rule-restricted.guard.ts